import { useTranslation } from 'next-i18next';
import { NeedHelpContent } from '..';
import { ContentWrapper, Label, Wrapper } from './NeedHelp.styles';

export function NeedHelp({ orderNumber }: { orderNumber?: string }) {
  const { t } = useTranslation(['lib-global-common']);

  return (
    <Wrapper data-testid="needHelpWrapper">
      <Label>{t('cart.need.help')}</Label>
      <ContentWrapper>
        <NeedHelpContent orderNumber={orderNumber} />
      </ContentWrapper>
    </Wrapper>
  );
}
